import { render, staticRenderFns } from "./VoiceTraining.vue?vue&type=template&id=76e23787&"
import script from "./VoiceTraining.vue?vue&type=script&lang=js&"
export * from "./VoiceTraining.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports